import { Box } from '@mui/material';

import { TableExample } from '../components/tables/TableExample';

export const TablePage = () => {
  return (
    <Box>
      <TableExample />
    </Box>
  );
};
